import React from 'react';

const IntellectualProperty: React.FC = () => {
  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold mb-2">Our Intellectual Property</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Service technology and infrastructure</li>
        <li>AI algorithms and system responses</li>
        <li>Branding, logos, and visual elements</li>
        <li>Website content and documentation</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Your Content Rights</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>You retain ownership of your personal conversations</li>
        <li>You grant us limited rights to provide the service</li>
        <li>We only use your content to:
          <ul className="list-disc pl-5 mt-2">
            <li>Deliver emotional support services to you</li>
            <li>Improve AI responses with your explicit consent</li>
            <li>Ensure service quality and safety</li>
          </ul>
        </li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">System Integrity Protection</h4>
      <div className="space-y-4">
        <div>
          <h5 className="font-medium mb-2">Reverse Engineering Prohibition</h5>
          <ul className="list-disc pl-5 space-y-2">
            <li>No attempts to reverse engineer AI models or algorithms</li>
            <li>No decompiling or disassembling any part of the service</li>
            <li>No extraction of training data or model parameters</li>
            <li>No recreation of proprietary systems</li>
          </ul>
        </div>

        <div>
          <h5 className="font-medium mb-2">Data Extraction Restrictions</h5>
          <ul className="list-disc pl-5 space-y-2">
            <li>No use of automated tools to scrape or extract data</li>
            <li>No downloading or compiling conversation datasets</li>
            <li>No systematic extraction of patterns or training examples</li>
            <li>No use of service primarily for data collection</li>
          </ul>
        </div>

        <div>
          <h5 className="font-medium mb-2">System Protection</h5>
          <ul className="list-disc pl-5 space-y-2">
            <li>No attempts to manipulate AI to bypass safety measures</li>
            <li>No testing for vulnerabilities without permission</li>
            <li>No intentional triggering of system errors</li>
            <li>No attempts to access administrative functions</li>
          </ul>
        </div>
      </div>

      <h4 className="text-lg font-semibold mb-2 mt-6">Usage Restrictions</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Personal, non-commercial use only</li>
        <li>No unauthorized copying of service elements</li>
        <li>No automated access without permission</li>
        <li>No distribution or modification of service components</li>
      </ul>

      <div className="bg-[#C2A4D6]/10 p-4 rounded-lg mt-6">
        <p className="text-sm text-gray-600">
          We respect your privacy and ownership rights while protecting our intellectual property. 
          These protections ensure we can maintain a secure, reliable service for all users while 
          safeguarding our technological innovations.
        </p>
      </div>
    </div>
  );
};

export default IntellectualProperty;